const MODULE_URL = 'filelists';
export default {
  MODULE_URL: MODULE_URL,
  SESSIONS_URL: MODULE_URL,

  SESSION_CREATED: 'filelist_created',
  SESSION_REMOVED: 'filelist_removed',
  SESSION_UPDATED: 'filelist_updated',

  DIRECTORY_DOWNLOADS_URL: MODULE_URL + '/directory_downloads',

  FIND_NFO_URL: MODULE_URL + '/find_nfo',
  MATCH_QUEUE_URL: MODULE_URL + '/match_queue',

  VIEW_ID: 'filelist',
};
